import { render } from "./elecBoardThread.vue?vue&type=template&id=d12266ea"
import script from "./elecBoardThread.vue?vue&type=script&lang=js"
export * from "./elecBoardThread.vue?vue&type=script&lang=js"

import exportComponent from "D:\\A_Projcets_Code\\mes-chunyu\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__